module.exports = __webpack_public_path__ + "static/media/feelingProud.2936ce95.svg";